var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-icon',{class:_vm.classes,attrs:{"size":_vm.size,"color":_vm.color,"name":'img:'+require('../assets/icons/' + _vm.name + '.svg')},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }